import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a00a01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "is-optional"
}
const _hoisted_3 = {
  key: 1,
  class: "tooltip"
}
const _hoisted_4 = ["aria-label", "disabled", "placeholder", "name"]
const _hoisted_5 = {
  key: 0,
  class: "status unit-symbol icon"
}

import { Field } from 'vee-validate'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import { toRefs } from 'vue'
import IconUI from '@/components/CommonUI/IconUI.vue'

interface Props {
  name: string,
  inputClass?: string,
  hideLabel?: boolean,
  label: string,
  optional?: boolean,
  value?: string,
  disabled?: boolean,
  placeholder?: string,
  tooltipInfoText?: string,
  unit?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    name: {},
    inputClass: { default: '' },
    hideLabel: { type: Boolean, default: false },
    label: {},
    optional: { type: Boolean, default: false },
    value: { default: undefined },
    disabled: { type: Boolean, default: false },
    placeholder: { default: '' },
    tooltipInfoText: { default: '' },
    unit: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const { value, name } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_unref(Field), _mergeProps({
    as: "div",
    name: _unref(name),
    value: _unref(value)
  }, _ctx.$attrs), {
    default: _withCtx(({ field, errorMessage, meta }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["field-container", { 'has-error': errorMessage && !meta.valid }])
      }, [
        _createElementVNode("label", {
          for: _unref(name),
          class: _normalizeClass({ 'screen-reader-only': _ctx.hideLabel })
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
          (_ctx.optional)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(optional)"))
            : _createCommentVNode("", true),
          (_ctx.tooltipInfoText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _withDirectives(_createVNode(IconUI, {
                  "data-testid": _unref(name),
                  name: "tooltip",
                  fill: "info"
                }, null, 8, ["data-testid"]), [
                  [_directive_tippy, { content: _ctx.tooltipInfoText }]
                ])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1),
        _createElementVNode("input", _mergeProps(field, {
          type: "text",
          "aria-label": _unref(name),
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          name: _unref(name),
          class: [_ctx.inputClass, { 'has-error': errorMessage && !meta.valid }]
        }), null, 16, _hoisted_4),
        (_ctx.unit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.unit), 1))
          : _createCommentVNode("", true)
      ], 2),
      (errorMessage && !meta.valid)
        ? (_openBlock(), _createBlock(NotificationUI, {
            key: 0,
            message: errorMessage,
            class: "input-error",
            type: "error outline",
            "icon-fill": "error",
            "icon-name": "danger"
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["name", "value"]))
}
}

})